import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Rate: FC<Props> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={classNames('w-[24px] h-[24px]', className)}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.31555C12.2474 2.31555 12.4734 2.45602 12.5829 2.67789L15.3674 8.32008L21.5932 9.22239C21.8382 9.2579 22.0418 9.42947 22.1182 9.66491C22.1947 9.90035 22.1308 10.1588 21.9534 10.3314L17.4418 14.7231L18.5056 20.9246C18.5474 21.1686 18.4471 21.4151 18.2468 21.5605C18.0464 21.7059 17.7809 21.7249 17.5619 21.6095L12.0063 18.6819L6.43752 21.6098C6.21852 21.725 5.95315 21.7058 5.75297 21.5603C5.5528 21.4149 5.45256 21.1685 5.49439 20.9246L6.55819 14.7231L2.04661 10.3314C1.86923 10.1588 1.80532 9.90035 1.88178 9.66491C1.95823 9.42947 2.16178 9.2579 2.40676 9.22239L8.6326 8.32008L11.4171 2.67789C11.5266 2.45602 11.7526 2.31555 12 2.31555ZM12 4.43429L9.64707 9.20199C9.55235 9.39391 9.36922 9.52691 9.15741 9.5576L3.89839 10.3198L7.71004 14.0301C7.86346 14.1794 7.93349 14.3948 7.8973 14.6058L6.99836 19.8462L11.7042 17.372C11.8937 17.2724 12.1202 17.2725 12.3097 17.3723L17.0014 19.8447L16.1027 14.6058C16.0665 14.3948 16.1365 14.1794 16.2899 14.0301L20.1016 10.3198L14.8426 9.5576C14.6308 9.52691 14.4476 9.39391 14.3529 9.20199L12 4.43429Z"
      fill="currentColor"
    />
  </svg>
);

export default Rate;
